export default {
  "首页": "ホーム",
  "订单": "注文",
  "新闻": "ニュース",
  "个人中心": "個人センター",
  "模拟账户": "デモアカウント",
  "可用资产": "利用可能な資産",
  "入金": "入金",
  "出金": "出金",
  "账单详情": "明細詳細",
  "重置模拟账户": "デモアカウントをリセット",
  "钱包": "ウォレット",
  "实名认证": "本人確認",
  "邀请好友": "友達を招待",
  "修改密码": "パスワードを変更",
  "投诉邮箱": "苦情メール",
  "其它": "その他",
  "公告": "お知らせ",
  "语言": "言語",
  "是否退出登录": "ログアウトしますか？",
  "复制": "コピー",
  "复制成功": "コピー成功",
  "发送验证码成功": "認証コード送信成功",
  "请输入密码": "パスワードを入力してください",
  "请再次输入密码": "もう一度パスワードを入力してください",
  "复制邀请链接": "招待リンクをコピー",
  "上传身份": "パスポート/身分証の表裏をアップロードしてください",
  "正面": "表面",
  "上传正面": "パスポート/身分証の表面をアップロード",
  "反面": "裏面",
  "上传反面": "パスポート/身分証の裏面をアップロード",
  "完善信息": "個人情報を入力してください",
  "输入姓名": "氏名を入力してください",
  "身份证号": "パスポート/身分証番号",
  "输入身份证号": "パスポート/身分証番号を入力してください",
  "收款货币": "受取通貨",
  "银行名称": "銀行名",
  "收款人账户": "受取人アカウント",
  "货币": "通貨",
  "分店名称": "支店名",
  "绑定银行卡": "銀行カードを紐づけ",
  "银行地址": "銀行住所",
  "账号名称（假名）": "アカウント名（仮名）",
  "绑定数字货币地址": "暗号通貨アドレスを紐づけ",
  "余额": "残高",
  "联系客服": "カスタマーサービスに連絡",
  "行情": "市場動向",
  "其他": "その他",
  "设置": "設定",
  "收款人": "受取人",
  "添加": "追加",
  "确认": "確認",
  "取消": "キャンセル",
  "钱包地址": "ウォレットアドレス",
  "请输入": "入力してください",
  "退出登录": "ログアウト",
  "充值数量": "チャージ金額",
  "提交": "送信",
  "银行卡": "銀行カード",
  "选择网络": "ネットワークを選択",
  "数字货币": "暗号通貨",
  "上传验证": "認証をアップロード",
  "提币地址": "出金アドレス",
  "数量(USD)": "数量（USD）",
  "备注": "備考",
  "手续费": "手数料",
  "预计到账数量": "到着予定数量",
  "暂无数据": "データがありません",
  "入金记录": "入金履歴",
  "提币记录": "出金履歴",
  "验证码": "認証コード",
  "邀请码": "招待コード",
  "提示": "ヒント",
  "请输入验证码": "認証コードを入力してください",
  "姓名": "氏名",
  "邮箱登录": "メールでログイン",
  "邮箱": "メール",
  "密码": "パスワード",
  "新用户": "新規ユーザー",
  "立即加入": "今すぐ参加",
  "忘记密码": "パスワードを忘れましたか",
  "登录": "ログイン",
  "无需开户,立即创建模拟账号进行交易!": "口座開設不要で、すぐにデモアカウントを作成して取引を開始！",
  "电话": "電話番号",
  "再次输入密码": "再度パスワードを入力してください",
  "职业": "職業",
  "年收入": "年間収入",
  "注册": "登録",
  "邮箱注册": "メール登録",
  "发送": "送信",
  "重置密码": "パスワードをリセット",
  "是否重置": "リセットしますか",
  "已重置": "リセット済み",
  "名称": "名称",
  "注册成功": "登録成功",
  "加载中": "読み込み中",
  "您还未登录，请先登录": "まだログインしていません。まずログインしてください。",
  "退出成功": "ログアウト成功",
  "市价": "市場価格",
  "挂单": "指値注文",
  "倍数": "倍率",
  "止盈": "利食い",
  "止损": "損切り",
  "买入数量": "購入数量",
  "每手": "1ロットあたり",
  "预估手续费": "推定手数料",
  "预估保证金": "推定証拠金",
  "买入": "購入",
  "卖出": "売却",
  "您的订单已确认": "注文が確認されました",
  "订单页面": "注文ページ",
  "盈亏": "損益",
  "当前保证金": "現在の証拠金",
  "订单详情": "注文詳細",
  "保证金": "証拠金",
  "平仓": "ポジションを閉じる",
  "修改": "修正",
  "手数": "ロット数",
  "暂无数据": "データがありません",
  "历史": "履歴",
  "价格": "価格",
  "请输入价格": "価格を入力してください",
  "手": "ロット",
  "搜索结果": "検索結果",
  "搜索产品": "商品を検索",
  "持仓": "保有ポジション",
  "语言": "言語",
  "审核中": "審査中",
  "请上传证件照正/反面": "身分証明書の表裏をアップロードしてください",
  "上传成功": "アップロード成功",
  "上传失败": "アップロード失敗",
  "提交成功": "送信成功",
  "删除": "削除",
  "删除成功": "削除成功",
  "提币": "出金",
  "缺少参数或传值错误": "パラメータが不足しているか値が間違っています",
  "操作成功": "操作成功",
  "充值金额": "チャージ金額",
  "类型": "タイプ",
  "状态": "ステータス",
  "时间": "時間",
  "单位": "単位",
  "最高价": "最高価格",
  "最低价": "最安値",
  "开盘价": "始値",
  "请注册或登录真实账号": "実際のアカウントを登録またはログインしてください",
  "没有更多了": "これ以上はありません",
  "提现金额": "引き出し金額",
  "审核通过": "承認済み",
  "审核不通过": "未承認",
  "重新提交": "再送信",
  "止盈价": "利食い価格",
  "止损价": "損切り価格",
  "总盈亏": "総損益",
  "撤单": "注文をキャンセル",
  "请先进行实名认证": "まず本人確認を行ってください",
  "产品列表": "製品リスト",
  "下单": "注文",
  "可用资金": "利用可能資金",
  "欢迎登录": "ログインを歓迎します",
  "可用": "利用可能",
  "冻结": "凍結",
  "财务记录": "財務記録",
  "交易对": "取引ペア",
  "开仓时间": "建玉開始時間",
  "收益": "収益",
  "操作": "操作",
  "下单价": "注文価格",
  "当前价": "現在の価格",
  "订单号": "注文番号",
  "请选择": "選択してください",
  "卖出(做空)止损价不能低于开仓价": "売却（ショート）のストップロス価格は開場価格より低くできません",
  "卖出(做多)止盈价不能高于开仓价": "売却（ロング）のテイクプロフィット価格は開場価格より高くできません",
  "买入(做多)止损价不能高于开仓价": "購入（ロング）のストップロス価格は開場価格より高くできません",
  "买入(做多)止盈价不能低于开仓价": "購入（ロング）のテイクプロフィット価格は開場価格より低くできません",
  "买入(做多)止盈价不能低于开仓价和现价": "購入（ロング）のテイクプロフィット価格は開場価格と現在の価格より低くできません",
  "买入(做多)止损价不能高于开仓价和现价": "購入（ロング）のストップロス価格は開場価格と現在の価格より高くできません",
  "卖出(做空)止损价不能低于开仓价和现价": "売却（ショート）のストップロス価格は開場価格と現在の価格より低くできません",
  "卖出(做多)止盈价不能高于开仓价和现价": "売却（ロング）のテイクプロフィット価格は開場価格と現在の価格より高くできません",

  "提现手续费": "引き出し手数料",
  "提现退回": "現金引き出し返品",
  "系统加款": "システム加款",
  "系统减款": "システム减款",

  "交易周期": "取引サイクル",
  "秒": "秒（びょう）",
  "交易额": "取引額",
  "买涨": "上昇を買う",
  "买跌": "下落を買う",
  "秒数": "秒数（びょうすう）",
  "交易类型": "取引種類",
  "看涨": "上昇見通し",
  "看跌": "下落見通し",
  "剩余时间": "残り時間",
  "买入价": "買い価格",
  "结算价": "決済価格",
  "交易额": "取引額",
  "下单时间": "注文時間",
  "结算时间": "決済時間",
  "该币种暂无交易": "当該通貨は取引されていない",

  "总资产": "総資産",
  "币种": "通貨種別",
  "资产折合": "資産換算",
  "冻结金额": "凍結金額",
  "可用金额": "利用可能金額",
  "公司资产": "会社資産",
  "请输入旧密码": "古いパスワードを入力してください",
  "请输入新密码": "新しいパスワードを入力してください",
  "请再次输入新密码": "新しいパスワードを再度入力してください",
  "白皮书": "ホワイトペーパー",
  "注册证书": "登録証明書",
  "MSB": "MSB",
  "上述信息最终解释权归官方所有": "上記情報の最終解釈権は公式に帰属します",
  "上一页": "前のページ",
  "下一页": "次のページ",
  "关闭": "閉じる",
  "闪电兑换": "ライトニング交換",
  "全部": "すべて",
  "可用余额": "利用可能残高",
  "到": "～まで",
  "请输入数量": "数量を入力してください",
  "币种选择": "通貨種別選択",
  "从": "～から",
  "兑换": "両替",
  "兑换成功！": "変換に成功しました！",
  "支付": "支払い",
  "全部兑换成功": "すべての両替が成功しました",
  "获取": "取得",
  "数量": "数量",
  "拒绝原因": "拒否理由",
  "交易密码": "取引パスワード",
  "设置交易密码": "取引パスワードを設定する",
  "重置交易密码": "取引パスワードをリセットする",
  "确定": "確認",
  "是否购买？": "購入しますか？",
  "外汇": "外国為替",
  "期权": "オプション",
  "(用户中心)": "(ユーザーセンター)",
  "您的交易正在处理中,请耐心等待交易完成再进行其他操作!": "取引を処理中です。他の操作を実行する前に、取引が完了するまでお待ちください。",
  "继续下单": "注文を続ける",
  "交易方向": "取引方向",
  "实现盈利": "利益を実現する",
  "最新价格": "最新価格",
  "结算完成": "決済完了",
  "下单余额不足": "注文残高が不足しています",
  "输入交易额度": "取引金額を入力してください",
  "选择交易周期": "取引期間を選択してください",
  "审核拒绝": "審査が拒否されました",
  "请输入正确的数量!": "正しい数量を入力してください！",
  "上传身份": "身分証をアップロード",
  "上传正面": "表面をアップロード",
  "上传反面": "裏面をアップロード",
  "完善信息": "情報を完備してください",
  "输入姓名": "氏名を入力してください",
  "输入身份证号": "身分証番号を入力してください",
  "身份证号": "身分証番号",
  "请上传证件照正/反面": "証明書の表裏の写真をアップロードしてください",
  "最小提现金额10USDT": "最低出金額は10USDTです",
  "证件号码": "身分証番号",
  "输入证件号码": "身分証番号を入力してください",
  "请上传身份证、驾驶证或护照其中一种进行身份认证！": "本人確認のため、身分証、運転免許証、またはパスポートのいずれかをアップロードしてください！"


}
